import React from "react";
import { STATS } from "../../mock/mock";

export default function StatsBar() {
  return (
    <section className="bg-[#fdfaf5]">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-14 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-y-8 gap-x-6 text-center">
          {STATS.map((s) => (
            <div key={s.big} className="px-2">
              <div className="font-serif-display text-2xl md:text-3xl lg:text-4xl text-[#7a1e2f]">{s.big}</div>
              <div className="mt-2 text-[11px] md:text-xs uppercase tracking-[0.18em] text-[#1a1a1a]/60">{s.small}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
